import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import '../component.css';
import {PALETTE, rgbaToHex, hexToColorObj, rgbaAlpha} from '../../utils/colors';
import {getRecents, subscribeRecents, setPendingCustom} from '../../utils/recents';
import '../canvas/canvas.css';

const RECENT_SLOTS = 5;

export default function Picker(props) {
    const {t} = useTranslation();
    const hex = rgbaToHex(props.color);
    const alpha = rgbaAlpha(props.color);
    const [recents, setRecents] = useState(getRecents());
    const colorInputRef = useRef(null);

    useEffect(function() {
        return subscribeRecents(function() { setRecents(getRecents()); });
    }, []);

    const recentSlots = [];
    for (var i = 0; i < RECENT_SLOTS; i++) {
        recentSlots.push(recents[i] || null);
    }

    return (
        <div className="Container">
            <div className="ComponentTitle">{t('picker.title')}</div>
            <div style={{ padding: 8 }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    gap: 6,
                    marginBottom: 8,
                }}>
                    {PALETTE.map(c => (
                        <button
                            key={c}
                            className={'mobile-color-swatch' + (hex === c.toLowerCase() ? ' mobile-color-swatch--active' : '')}
                            style={{ background: c, width: '100%', aspectRatio: '1' }}
                            onClick={() => props.onChangeComplete(hexToColorObj(c, props.isGuessMode ? 1 : alpha))}
                        />
                    ))}
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(' + RECENT_SLOTS + ', 1fr)',
                    gap: 6,
                    marginBottom: 8,
                }}>
                    {recentSlots.map(function(c, idx) {
                        if (c) {
                            return (
                                <button
                                    key={'r' + idx}
                                    className={'mobile-color-swatch' + (hex === c.toLowerCase() ? ' mobile-color-swatch--active' : '')}
                                    style={{ background: c, width: '100%', aspectRatio: '1' }}
                                    onClick={() => props.onChangeComplete(hexToColorObj(c, props.isGuessMode ? 1 : alpha))}
                                />
                            );
                        }
                        return (
                            <button
                                key={'r' + idx}
                                className="mobile-color-swatch mobile-color-swatch--empty"
                                style={{ width: '100%', aspectRatio: '1' }}
                                onClick={function() { if (colorInputRef.current) colorInputRef.current.click(); }}
                            />
                        );
                    })}
                </div>
                <div style={{ position: 'relative' }}>
                    <input
                        ref={colorInputRef}
                        type="color"
                        value={hex}
                        onChange={(e) => {
                            setPendingCustom(e.target.value);
                            props.onChangeComplete(hexToColorObj(e.target.value, props.isGuessMode ? 1 : alpha));
                        }}
                        className="mobile-color-custom"
                        title={t('tools.customColor')}
                    />
                    <span style={{
                        position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
                        fontSize: 16, fontWeight: 'bold', pointerEvents: 'none', lineHeight: 1,
                        color: '#fff', letterSpacing: 2,
                        textShadow: '0 1px 2px #000, 0 -1px 2px #000, 1px 0 2px #000, -1px 0 2px #000',
                    }}>...</span>
                </div>
                {false && !props.isGuessMode && (
                    <div style={{ marginTop: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ fontSize: 12, color: '#ccc', minWidth: 46 }}>
                                {t('picker.opacity', 'Opacity')}
                            </span>
                            <input
                                type="range"
                                min="0"
                                max="100"
                                value={Math.round(alpha * 100)}
                                onChange={(e) => {
                                    var a = Number(e.target.value) / 100;
                                    props.onChangeComplete(hexToColorObj(hex, a));
                                }}
                                style={{ flex: 1 }}
                            />
                            <span style={{ fontSize: 11, color: '#aaa', minWidth: 30, textAlign: 'right' }}>
                                {Math.round(alpha * 100)}%
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}